import jshelper from '@/libs/helper';

const encapsulateHTML = html => `<div class="sidebar-sub-item">${html}</div>`;

const createHtmlItems = (obj, mapper) => {
  let htmlData = '';
  Object.keys(obj).forEach((key) => {
    htmlData += `<strong>${mapper[key]}:</strong> ${jshelper.decodeHtml(obj[key] || '-')}<br/>`;
  });
  return htmlData;
};

const addressHandler = (obj, mapper, displayApn) => {
  const address = {
    address: obj.address,
    city: obj.city,
    state: obj.state,
    unit: obj.unit,
    zipCode: obj.zipCode,
    lotSize: obj.lotSize,
    bedrooms: obj.bedrooms,
    total_baths_calculated: obj.total_baths_calculated,
    sqft: obj.building_sqft,
  };

  if (displayApn) {
    address.apn = obj.apn;
  }

  const htmlData = createHtmlItems(address, mapper);
  return `${encapsulateHTML(htmlData)}`;
};


export default {
  encapsulateHTML,
  createHtmlItems,
  addressHandler,
};



// WEBPACK FOOTER //
// ./src/components/base/sidebar/resources/helper.js